(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-faq';
  var TRIGGER_SELECTOR = '[data-faq-trigger]';
  var ANSWER_SELECTOR = '[data-faq-answer]';

  function toggleItem(trigger) {
    var item = trigger.closest('[data-faq-item]');
    if (!item) return;

    var answer = item.querySelector(ANSWER_SELECTOR);
    if (!answer) return;

    var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    var nextExpanded = !isExpanded;

    trigger.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
    answer.setAttribute('aria-hidden', nextExpanded ? 'false' : 'true');

    if (nextExpanded) {
      answer.removeAttribute('hidden');
    } else {
      answer.setAttribute('hidden', '');
    }
  }

  function handleClick(event) {
    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;
    event.preventDefault();
    toggleItem(trigger);
  }

  function initSection(section) {
    if (!section || section.dataset.oddItFaqInit === 'true') return;
    section.dataset.oddItFaqInit = 'true';
    section.addEventListener('click', handleClick);
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();